import { render } from "./GlobalContainer.vue?vue&type=template&id=6e35306a"
import script from "./GlobalContainer.vue?vue&type=script&lang=js"
export * from "./GlobalContainer.vue?vue&type=script&lang=js"

import exportComponent from "/Users/reinlabares/Labs/imwt/crawl-ui/crawl-interface/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__